module.exports = __webpack_public_path__ + "static/img/img12.3823ff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img12.jpg
// module id = hwrd
// module chunks = 1